export default {
  header: {
    products: 'Produits',
    events: 'Évènements',
    societe: 'Société',
    exhibitor: 'Entreprises',
    users: 'Utilisateurs',
    company_settings: 'Paramètres',
    sign_out: 'Se déconnecter',
    categories: 'Catégories',
    subcategories: 'SousCatégories',
    universes: 'Univers',
  },
  eventList: {
    question: 'Questionnaire',
    exhibitor: 'Exposants',
    events: 'Info de l’évenement',
    offers: 'Offres',
    forms: 'Formulaires',
    offerEditor: "Editeur d'Offres",
    websiteEditor: 'Editeur site web',
    floorMap: 'Floor Map',
    pdfEditor: 'Editeur PDF',
    exhibitorsWebsite: 'Site Web Exposants',
  },
};
